/** AGM 스튜디오 공통 패널 설정 — 프리셋(B32201/02/03/04)별로 기존 모델·빌더·문서 분류를 꽂는다. */
import type { Component } from 'vue';

export interface AgmStudioDocDef {
  comp: Component;
  props?: Record<string, any>;
}

/** 스튜디오에 보이는 문서 1건(생성 제외 문서는 사유와 함께 아래에 표시) */
export interface AgmStudioDocSlot { key: string; name: string; comp: Component; props?: Record<string, any>; included: boolean; reason?: string }

export interface AgmStudioConfig {
  tag: string;
  title: string;
  subtitle: string;
  createModel: () => Record<string, any>;
  /** 문서 [[변수]] ↔ 모델 필드 */
  fieldMap: Array<[string, string]>;
  /** 모델 값 대신 문서에 보일 값(예: AR 연도 미입력 시 FYE+1) */
  display?: Partial<Record<string, (m: any) => string>>;
  applyProfile: (model: any, payload: Record<string, any>) => void;
  withAuditor: boolean;
  withChairman: boolean;
  /** 템플릿명 → 문서 종류 (기존 classify*) */
  classify: (templateName: string) => string;
  /** 문서 종류 → 화면 컴포넌트 */
  docFor: (kind: string) => AgmStudioDocDef | null;
  /** 현재 옵션으로 이 문서가 생성되는지(기존 shouldIncludeDoc 와 같은 규칙) + 제외 사유 */
  include: (kind: string, model: any) => { included: boolean; reason?: string };
  toTemplateVariables: (model: any) => Record<string, any>;
  buildTaskFormData: (model: any, entityCd: string) => Record<string, any>;
  /** 기존 build*PresetPrepareDocuments — 문서 저장 payload + 서명자 미리보기에 그대로 사용 */
  buildPrepareDocuments: (input: {
    selectionDocuments: Array<{ tmpId?: number | string | null; templateName?: string }>;
    commonFormData: Record<string, any>;
    formModel: any;
    personName: string;
    entityCd?: string;
  }) => Array<Record<string, any>>;
  /** Edit 스냅샷 형식 — 기존 패널과 동일하게: 'nested' = {formModel}, 'flat' = 모델 그대로 */
  snapshot: 'nested' | 'flat';
}

/** 회원 유형별 회의록/회원결의 제외 사유 */
export function memberTypeRule(kind: string, model: any, prefix: 'minutes' | 'members_resolution'): { included: boolean; reason?: string } | null {
  const map: Record<string, string> = {
    [`${prefix}_multiple`]: 'multiple',
    [`${prefix}_sole_corporate`]: 'sole_corporate',
    [`${prefix}_sole_individual`]: 'sole_individual',
  };
  const need = map[kind];
  if (!need) return null;
  const label: Record<string, string> = { multiple: 'Multiple Members', sole_corporate: 'Sole Corporate Member', sole_individual: 'Sole Individual Member' };
  return model.memberType === need ? { included: true } : { included: false, reason: `member type is not ${label[need]}` };
}
